//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    UNIT_TYPE_EVENTS_SHOW
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery } from 'Core/data/GraphQLApi';
import moment from 'moment'

import {
    showUnitTypeEventsGetDataResult
} from 'Redux/actions';

function* searchUnitTypeEvents({ payload }) {
    try {
        const { unitTypeId } = payload;

        let QUERY = `
            query searchUnitTypeEvents ($conditions: [UnitTypeEventSearchInput], $sort: [UnitTypeEventSortInput], $limit: Int, $offset: Int) {
                result: searchUnitTypeEvents (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        rawEvent
                        unitTypeId
                        splitEventIndex
                        splitEventValue
                        event {
                            name
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["unitType_Id"],
                    terms: [unitTypeId],
                    exact: true
                },
                limit: 400,
                offset: 0,
                sort: {
                    field: "id",
                    order: "ASC"
                }
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(showUnitTypeEventsGetDataResult(data?.result))
        } else {
            yield put(showUnitTypeEventsGetDataResult([]))
        }
    } catch (exc) {
        yield put(showUnitTypeEventsGetDataResult({ error: exc }));
        ExceptionManager(
            exc,
            "Manufacturers/.components/unitTypesTab/.components/showUnitTypeEvents/redux/saga",
            "searchUnitTypeEvents"
        )
    }
}

function* watchMethods() {
    yield takeEvery(UNIT_TYPE_EVENTS_SHOW, searchUnitTypeEvents);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}